// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legend-panel[data-v-4e817884]{height:100%;overflow:hidden;display:flex;flex-direction:column}.legend-panel .container-form[data-v-4e817884]{flex:1 1 auto;min-height:0;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
